import { EmptyVisual } from './EmptyVisual'

interface PermissionEmptyStateProps {
  /** Kept for source compatibility — the line says it in four words. */
  subject?: string
  className?: string
  fullScreen?: boolean
  /** Optional escape hatch, e.g. "Back to Tasks" on detail routes. */
  actionLabel?: string
  onAction?: () => void
}

/**
 * Standard read-permission denial: the locked tone, one line, one hint with
 * the next step, no paragraph about where access comes from.
 */
export function PermissionEmptyState({
  className,
  fullScreen,
  actionLabel,
  onAction,
}: PermissionEmptyStateProps) {
  return (
    <EmptyVisual
      shape="icon"
      tone="locked"
      line="You don't have access"
      hint="Ask an admin if you need it."
      action={
        actionLabel && onAction
          ? { label: actionLabel, onClick: onAction }
          : undefined
      }
      fullScreen={fullScreen}
      className={className}
    />
  )
}
